import angular from 'angular';
import contactAddresses from './contactAddresses';
import './style.scss';

export default angular
  .module('components.contactAddresses', [])
  .component('contactAddresses', contactAddresses).name;
